import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  CadPadTermsComponent, OrganizationTermsComponent,
  ParentTermsComponent, TermsComponent, TermsViewComponent, UsdPadTermsComponent,
} from './views';

const routes: Routes = [
  {
    path: '',
    component: TermsComponent,
    pathMatch: 'full',
  },
  {
    path: 'parent',
    component: ParentTermsComponent,
  },
  {
    path: 'organization',
    component: OrganizationTermsComponent,
  },
  {
    path: 'cad-pad',
    component: CadPadTermsComponent,
  },
  {
    path: 'usd-pad',
    component: UsdPadTermsComponent,
  },
  {
    path: 'view/:type',
    component: TermsViewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TermsRoutingModule { }
